import { ProjectPageSection } from './project-page-section';

export interface ProjectPage {
    id: number;
    name: string;
    sections: ProjectPageSection[];
    target: number;
}
